export const NavBarAllowedViewFields = {
  ActionButtonView: () => import("./ActionButtonView"),

}
